export const GET_ALQURANGURU_SUCCEED = "alquranguru/get/succeed";
export const GET_ALQURANGURU_REQUEST = "alquranguru/get/request";
export const GET_ALQURANGURU_FAILED = "alquranguru/get/failed";

export const GET_ALQURANGURUAWAL_SUCCEED = "alquranguru/getawal/succeed";
export const GET_ALQURANGURUAWAL_REQUEST = "alquranguru/getawal/request";
export const GET_ALQURANGURUAWAL_FAILED = "alquranguru/getawal/failed";

export const CREATE_ALQURANGURU_REQUEST = "alquranguru/create/request";
export const CREATE_ALQURANGURU_SUCCEED = "alquranguru/create/succeed";
export const CREATE_ALQURANGURU_FAILED = "alquranguru/create/failed";

export const DELETE_ALQURANGURU_REQUEST = "alquranguru/delete/request";
export const DELETE_ALQURANGURU_SUCCEED = "alquranguru/delete/succeed";
export const DELETE_ALQURANGURU_FAILED = "alquranguru/delete/failed";

export const GET_BY_ID_ALQURANGURU_REQUEST = "alquranguru/getid/request";
export const GET_BY_ID_ALQURANGURU_SUCCEED = "alquranguru/getid/succeed";
export const GET_BY_ID_ALQURANGURU_FAILED = "alquranguru/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_ALQURANGURU_REQUEST =
  "alquranguru/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_ALQURANGURU_SUCCEED =
  "alquranguru/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_ALQURANGURU_FAILED =
  "alquranguru/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_ALQURANGURU_REQUEST =
  "alquranguru/getbymastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_ALQURANGURU_SUCCEED =
  "alquranguru/getbymastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_ALQURANGURU_FAILED =
  "alquranguru/getbymastertahfidz/failed";

export const UPDATE_ALQURANGURU_REQUEST = "alquranguru/update/request";
export const UPDATE_ALQURANGURU_SUCCEED = "alquranguru/update/succeed";
export const UPDATE_ALQURANGURU_FAILED = "alquranguru/update/failed";
